export default __webpack_public_path__ + "static/francis-1818102d72b79dfb4e9aad1edbceb901.jpg";